import { Component, Object3D } from '@wonderlandengine/api';
import { property } from '@wonderlandengine/api/decorators.js';
import { GlobalEvents } from '../core/global-events.js';
import { wlUtils } from '@sorskoot/wonderland-components';

export class HideHandOnGrab extends Component {
    static TypeName = 'hide-hand-on-grab';

    @property.object({ required: true })
    hand!: Object3D;

    @property.enum(['left', 'right'], 'left')
    handedness: number = 0;

    onActivate(): void {
        GlobalEvents.instance.interactableGrabbed.add(this._onGrab, this);
        GlobalEvents.instance.interactableReleased.add(this._onRelease, this);
    }

    onDeactivate(): void {
        GlobalEvents.instance.interactableGrabbed.remove(this._onGrab);
        GlobalEvents.instance.interactableReleased.remove(this._onRelease);
    }

    private _onGrab = (handedness: 'left' | 'right', object: Object3D) => {
        if (handedness === ['left', 'right'][this.handedness]) {
            wlUtils.setActive(this.hand, false);
        }
    };

    private _onRelease = (handedness: 'left' | 'right', object: Object3D) => {
        if (handedness === ['left', 'right'][this.handedness]) {
            wlUtils.setActive(this.hand, true);
        }
    };
}
